import React from 'react' 

function Header() {
  return (
    <h3 >
       <a href='#/' className='md:text-6xl text-4xl text-lightblue pt-10 font1 leftStyle '>Movie App</a>
    </h3>
  )
}

export default Header